export default __webpack_public_path__ + "static/health4-851c62e2bbb185185d2aacc498759351.png";